import { cloneDeep, get, isPlainObject, mergeWith, set } from 'lodash';

import { t } from '@ezbobdev/ui-framework';

import defaultConfig from '../config/config';
import { cleanInterpolationCharacters } from '../utils/commons';
import { i18n } from '../utils/translations';

export const SettingsActions = {
  /**
   * get state's config by prop
   * @param {string} prop - path by which to find prop in config
   * @returns {Object} found value in config
   */
  getUserConfigProp(prop) {
    if (prop) {
      const interpolationRegex = new RegExp(/{{[\s\S]+}}/);
      const configProp = get(this.state.config, prop);
      const defaultConfigProp = get(defaultConfig, prop);

      if (isPlainObject(configProp) && isPlainObject(defaultConfigProp)) {
        return mergeWith(defaultConfigProp, configProp, (objValue, srcValue) => {
          if (interpolationRegex.test(srcValue)) {
            srcValue = get(this.state.config, cleanInterpolationCharacters(srcValue));

            return srcValue ?? objValue;
          }

          if (Array.isArray(objValue) && Array.isArray(srcValue)) {
            return srcValue;
          }
        });
      } else {
        if (configProp !== undefined) {
          return interpolationRegex.test(configProp)
            ? get(this.state.config, cleanInterpolationCharacters(configProp))
            : configProp;
        }
        return defaultConfigProp;
      }
    } else {
      return this.state.config;
    }
  },

  setUserConfigProp(prop, value) {
    this.setState((prevState) => {
      const config = cloneDeep(prevState.config);
      set(config, prop, value);
      return {
        ...prevState,
        config,
      };
    });
  },

  getPageRoute(routeName) {
    return get(this.state.config, `pageRoutes.${routeName}`);
  },

  setPageRoute(routeSettings, routePath) {
    this.setState((prevState) => ({
      ...prevState,
      view: {
        ...prevState.view,
        errorMessages: [],
        routeSettings: { ...routeSettings, routePath },
        modal: {},
      },
    }));

    if (routeSettings && routeSettings.title) {
      document.title = t(routeSettings.title);
    }
  },

  updateTranslationValue({ lang, key, value }) {
    const path = ['languages', 'languageList', lang, 'translation', ...key.split('.')];

    this.setState((prevState) => {
      const updatedConfig = cloneDeep(prevState.config);
      set(updatedConfig, path, value);

      i18n.addResource(lang, 'translation', key, value);
      return { config: updatedConfig };
    });
  },
};
